import { components } from "react-select";

export const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="dropdown">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            className="checkbox"
          />
          <div className="option">
            <h2 className="label">{props.label}</h2>
            <p className="desc"> {props.data.description}</p>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
